import React from 'react'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Box, Card, CardContent, Typography } from '../../../../components/mui/Core/index'
import FormHeading from '../../../../components/userauthentication/FormHeading'
import { resendInviteCompleteConstants } from '../../../../constants/resend-invite-constants'

function ResendPasswordSuccess() {
  const theme = useTheme()

  const cardContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }
  const messageContainerStyle = { textAlign: 'center', marginTop: '12px' }

  return (
    <Box sx={theme.soloContainer}>
      <Card className='soloCard'>
        <CardContent sx={cardContentStyle}>
          <FormHeading formHeader={resendInviteCompleteConstants.HEADING} />
          <Box sx={messageContainerStyle}>
            <Typography variant='cardMessage'>
              {resendInviteCompleteConstants.COMPLETE_MESSAGE_1}
              <br />
              {resendInviteCompleteConstants.COMPLETE_MESSAGE_2}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default ResendPasswordSuccess
